__turbopack_context__.v({
  "error-message": "ijy_Ma_error-message",
  "placeholder": "ijy_Ma_placeholder",
  "slider": "ijy_Ma_slider",
  "slider-columns-2": "ijy_Ma_slider-columns-2",
  "slider-columns-3": "ijy_Ma_slider-columns-3",
  "wrapper": "ijy_Ma_wrapper",
});
